import React from 'react';
import { ShieldCheck, Award } from 'lucide-react';
import { content } from '../data/content';

const Menu = () => {
  return (
    <section id="menu" className="py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-2 bg-green-600/10 border border-green-600/20 rounded-full px-6 py-2 mb-8">
            <ShieldCheck className="w-5 h-5 text-green-500" />
            <span className="text-green-500 font-semibold text-sm tracking-wider">
              100% CERTIFICATO GLUTEN FREE
            </span>
          </div>
          
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-8">
            {content.menu.title}
          </h2>
          
          <p className="text-xl text-amber-100/60 max-w-3xl mx-auto mb-4 font-light leading-relaxed">
            {content.menu.description}
          </p>
          
          <div className="w-24 h-1 bg-amber-500/40 mx-auto mt-8"></div>
        </div>

        {/* Menu Items */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {content.menu.items.map((item, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-amber-50/5 to-transparent border border-amber-200/10 rounded-xl p-6 hover:border-red-500/30 transition-all duration-300 hover:scale-105"
            >
              <h3 className="text-xl font-bold text-amber-50 mb-2 group-hover:text-amber-100 transition-colors">
                {item.name}
              </h3>
              <p className="text-amber-100/70 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="bg-gradient-to-r from-amber-50/5 via-amber-50/10 to-amber-50/5 border border-amber-200/20 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <div className="flex items-center space-x-3">
              <Award className="w-8 h-8 text-amber-500" />
              <span className="text-amber-50 font-bold text-lg">Certificazioni:</span>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              {content.menu.certifications.map((cert, index) => (
                <div
                  key={index}
                  className="bg-amber-50/10 border border-amber-200/20 rounded-lg px-6 py-3"
                >
                  <span className="text-amber-100 font-semibold">{cert}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
